import React, { useContext, useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import StudentNavbar from '../StudentNavbar/StudentNavbar';
import Sidebar from '../StudentSidebar/Sidebar';
import RoutesPath from '../../Utils/RoutesPath';
import StudentDashboardServices from '../../Services/StudentDashboardApiService';
import { handleApiErrors } from '../../Utils/Utils';
import SubmitButtonTwo from '../../Components/Reusable/Buttontwo';
import parse from "html-react-parser";
import { PngImages } from '../../Utils/LocalImages';
import Image from '../../Components/Reusable/Image';
import { CirclesWithBar, RotatingLines } from 'react-loader-spinner'; // Import the loader from react-loader-spinner
import { AuthContext } from '../../Context/authContext';
import { toast } from 'react-toastify';

const PackageDetails = () => {
  const { user, updateUserCartCount } = useContext(AuthContext);
  const { packageId } = useParams(); // Get package ID from the URL
  const [packageData, setPackageData] = useState(null);
  const [packageDataId, setPackageDataId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingTwo, setLoadingTwo] = useState(false);
  const navigate = useNavigate()


  const getAllPackages = async () => {
    setLoading(true);
    try {
      const response = await StudentDashboardServices.getAllPackages();
      setPackageData(response.packages);
      // setAvailableDataCount(response.availableDataCount);
    } catch (error) {
      handleApiErrors(error);
    }
    finally {
      setLoading(false);
    }
  };


  const getAllPackagesByID = async (id) => {
    try {
      const response = await StudentDashboardServices.getAllPackagesByID(id);
      setPackageDataId(response.packageDetails);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const onSubmit = async (packageDataId) => {
    setLoadingTwo(true);
    try {
      const response = await StudentDashboardServices.addToCart(
        packageDataId.package_id,
      );
      updateUserCartCount(response.cartData.cartCount);
      if (response.message == "Success") {
        toast.success("Package Added Successfully!");
        navigate(RoutesPath.addtocart)
      }
      else {
        toast.success(response.message);
      }

    } catch (error) {
      setLoadingTwo(false);
      handleApiErrors(error);
    }
  };
  useEffect(() => {
    if (packageId) {
      getAllPackagesByID(packageId);
    }
  }, [packageId]);
  useEffect(() => {
    getAllPackages();
  }, []);

  const customParser = (node) => {
    if (node.name === "oembed") {
      const url = node.attribs.url;
      let videoId;
      // Handle both normal YouTube URLs (youtube.com) and short URLs (youtu.be)
      if (url.includes("youtube.com")) {
        videoId = new URL(url).searchParams.get("v");  // Extract the video ID from the "v" parameter
      } else if (url.includes("youtu.be")) {
        videoId = url.split("/").pop().split("?")[0];  // Extract the ID after the last "/"
      }
      if (videoId) {
        return (
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${videoId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube video"
          />
        );
      } else {
        return <p className='text-danger'>Invalid YouTube URL</p>;
      }
    }
  };


  return (
    <div className="d-flex">
      <Sidebar /> {/* Sidebar component */}
      <div className="mainLayout-content">
        <StudentNavbar /> {/* Navbar component */}
        <div className="main_content contentSection scroll_bar">
          <div className=" mb-3 justify-content-between align-items-center">
            <Link to={RoutesPath.dashboardstudent}>
              <div className="text-end justify-content-end d-flex" style={{ paddingRight: "10px" }}>
                <h4 className="Caption fw-600 mb-0"><span className='orangeAccentColor'>Back</span> &gt;</h4>
              </div>
            </Link>
            {loading ? (
              <div className="text-center d-flex justify-content-center">
                <CirclesWithBar
                  height="80"
                  width="80"
                  color="#F6821F"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : packageDataId ? (
              <>
                <div className='w-100'>
                  <h1 className="black Heading fw-700 text-capitalize" style={{
                    color: "#F6821F",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                  }}>
                    {packageDataId.packageName}
                  </h1>
                </div>


                <div className="d-flex mb-3 row">
                  <div className='col-md-6 d-flex align-items-center '>
                    <span className="disprice Small-Heading fw-600 pe-2">&#x20b9;{packageDataId.discountedPrice}</span>
                    <div className="originalprice medium-text fw-400 pb-3">&#x20b9;{packageDataId.actualPrice}</div>
                  </div>
                  <div className='col-md-6 d-flex justify-content-end '>
                    {loadingTwo ? (
                      <div className="text-center d-flex justify-content-center me-4 buynowbtn">
                        <RotatingLines
                          height="30"
                          width="30"
                          strokeColor="#F6821F"
                          ariaLabel="bars-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      <SubmitButtonTwo title={'Add To Cart'} className="buynowbtn" onclick={() => onSubmit(packageDataId)}></SubmitButtonTwo>

                    )}
                  </div>
                </div>
                <div className="hrline mb-4"></div>

                <div className="w-100 fw-500 blog-data-html" style={{ contain: "content" }}>
                  {packageDataId?.details &&
                    parse(packageDataId.details, { replace: customParser })}
                </div>
              </>
            ) : (
              <div className="no-records-container text-center">
                <div className="no-record-image">
                  <Image src={PngImages.no_record} className="img-fluid" />
                </div>
                <p className="no-records-text sub-large-text-one fw-700 mb-4">No records found</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PackageDetails;
